var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.588 8.47468C21.9785 8.08416 21.9785 7.451 21.588 7.06047L15.224 0.69651C14.8335 0.305986 14.2003 0.305986 13.8098 0.69651C13.4193 1.08703 13.4193 1.7202 13.8098 2.11072L19.4666 7.76758L13.8098 13.4244C13.4193 13.815 13.4193 14.4481 13.8098 14.8386C14.2003 15.2292 14.8335 15.2292 15.224 14.8386L21.588 8.47468ZM0.880859 8.76758H20.8809V6.76758H0.880859V8.76758Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow3);
export default __webpack_public_path__ + "static/media/Arrow 3.600cc597efae6074d668bf937b90ddc6.svg";
export { ForwardRef as ReactComponent };